import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as urls from '../utilities/urls';
import { NzTableData } from '../utilities/nz-table.adapter';
import { TransactionAccountTypeOptions, TransactionAccountTypes, UserTypes } from '../utilities/common-file';
import { MerchantTransactionSearch } from '../models/merchant-transactions';
import { AuthService } from '../auth/auth.service';
import { AttachmentSearch } from '../models/attachments';
import { CommentSearch } from '../models/comments';

@Injectable({
    providedIn: 'root',
})
export class SettlementService {
    constructor(private httpClient: HttpClient, private authService: AuthService) {}
getTransactionsForSettlementWithLimit(tableData: NzTableData<MerchantTransactionSearch, any>) {
  const value = {
    startDate: tableData.search.createdDate.startDate ? tableData.search.createdDate.startDate : '',
    endDate: tableData.search.createdDate.endDate ? tableData.search.createdDate.endDate : '',
    transactionStatus: tableData.search.transactionStatus,
    transactionType: tableData.search.transactionType,
    isSettled: tableData.search.isSettled,
    // accountTypeIn: (tableData.search.accountType !== null && tableData.search.accountType !== '') ? tableData.search.accountType :
    // // tslint:disable-next-line: max-line-length
    // [TransactionAccountTypes.qrPayment, TransactionAccountTypes.externalPayment, TransactionAccountTypes.settlement, TransactionAccountTypes.refund],
    mobileNo: tableData.search.type === 'mobile_no' ? tableData.search.number  : '',
    accountNo: tableData.search.type === 'account_no' ? tableData.search.number  : '',
    // tslint:disable-next-line: radix
    id: tableData.search.id ? parseInt(tableData.search.id) : '',
    displayName: tableData.search.name,
    merchantId: tableData.search.merchantId ? tableData.search.merchantId : '',
    locationId: tableData.search.locationId ? tableData.search.locationId : '',
    isOrderDelivered: tableData.search.isOrderDelivered ? tableData.search.isOrderDelivered : '',
    pageSize: tableData.pageSize,
    pageIndex: tableData.pageIndex
};
  return this.httpClient.post(urls.MerchantTransactionUrls.transactionList, value);
}
// Get settlement pending with page Limit
getMerchantSettlementPendingWithLimit(tableData: NzTableData<MerchantTransactionSearch, any>) {
  const value = {
    merchantId: tableData.search.merchantId ? tableData.search.merchantId : '',
    // locationId: tableData.search.locationId ? tableData.search.locationId : '',
    isSettlement:tableData.search.isSettlement,
    appCode: tableData.search.appCode,
    pageSize: tableData.pageSize,
    pageIndex: tableData.pageIndex
};
   return this.httpClient.post(urls.MerchantSettlementUrls.merchantSettlementSummary, value);
}
getMerchantSettlementPending(value) {
  return this.httpClient.post(urls.MerchantSettlementUrls.merchantSettlementSummary, value);
}
settlementCalculation(value) {
  return this.httpClient.post(urls.MerchantSettlementUrls.merchantSettlementCalculation, value);
}
claimAmount(value) {
    return this.httpClient.post(urls.MerchantSettlementUrls.settlement, value);
}
demandSettlement(value) {
  return this.httpClient.post(urls.MerchantSettlementUrls.demandSettlement, value);
}
runMerchantSettlement(value){
  return this.httpClient.post(urls.MerchantSettlementUrls.runMerchantSettlement,value)
}
getSettlementDocumentsWithLimit(tableData: NzTableData<MerchantTransactionSearch, any>) {
  const value = {
    merchantId: this.authService.getMerchantId(),
    locationId: tableData.search.locationId ? tableData.search.locationId : '',
    startDate: tableData.search.createdDate.startDate ? tableData.search.createdDate.startDate : '',
    endDate: tableData.search.createdDate.endDate ? tableData.search.createdDate.endDate : '',
    id: tableData.search.id,
    status: tableData.search.status,
    settlementStatus: tableData.search.settlementStatus,
    pageSize: tableData.pageSize,
    pageIndex: tableData.pageIndex
};
  return this.httpClient.post(urls.MerchantSettlementUrls.settlementDocument, value);
}
completePayment(value) {
  return this.httpClient.post(urls.MerchantSettlementUrls.completePayment, value);
}
repost(value) {
  return this.httpClient.post(urls.MerchantSettlementUrls.repost, value);
}
repostForCanada(value) {
  return this.httpClient.post(urls.MerchantSettlementUrls.repostForCanada, value);
}
downloadReportForMerchantSettlement(value) {
  return this.httpClient.post(urls.MerchantSettlementUrls.settlementDocument, value);
}
merchantTransactionSummary(tableData: NzTableData<MerchantTransactionSearch, any>) {
  const value = {
    merchantId: tableData.search.merchantId ? tableData.search.merchantId : '',
    startDate: tableData.search.createdDate.startDate ? tableData.search.createdDate.startDate : '',
    endDate: tableData.search.createdDate.endDate ? tableData.search.createdDate.endDate : '',
    isSettled: tableData.search.isSettled,
    paymentMethod: tableData.search.paymentMethod ? tableData.search.paymentMethod : '',
    accountTypeIn: TransactionAccountTypeOptions.map((item) => item.value),
      mobileNo: tableData.search.type === 'mobile_no' ? (tableData.search.number ? tableData.search.number.toString() : '') : '',
      accountNo: tableData.search.type === 'account_no' ? tableData.search.number : '',
      name: tableData.search.name,
      locationId: tableData.search.locationId ? tableData.search.locationId : '',
      role:UserTypes.appUser
  };
  return this.httpClient.post(urls.MerchantTransactionUrls.summaryList, value);
}
merchantTransactionSummary2(tableData: NzTableData<MerchantTransactionSearch, any>) {
  const value = {
    merchantId: tableData.search.merchantId ? tableData.search.merchantId : '',
    startDate: tableData.search.createdDate.startDate ? tableData.search.createdDate.startDate : '',
    endDate: tableData.search.createdDate.endDate ? tableData.search.createdDate.endDate : '',
    isSettled: tableData.search.isSettled,
    paymentMethod: tableData.search.paymentMethod ? tableData.search.paymentMethod : '',
    accountTypeIn: tableData.search.accountType ? tableData.search.accountType :[""],
      mobileNo: tableData.search.type === 'mobile_no' ? (tableData.search.number ? tableData.search.number.toString() : '') : '',
      accountNo: tableData.search.type === 'account_no' ? tableData.search.number : '',
      name: tableData.search.name,
      locationId: tableData.search.locationId ? tableData.search.locationId : '',
      role:UserTypes.appUser
  };
  return this.httpClient.post(urls.MerchantTransactionUrls.summaryList, value);
}
}
